import I18n from 'I18n';
import { useEffect, useState } from 'react';
import { checkEventDateIntervalLimit, toEventDateInterval
// @ts-expect-error untyped import
} from '../../event-date-interval-utils';
import { IN_NEXT_TIME_UNIT } from 'customer-data-filters/converters/objectSeg/ObjectSegOperatorTypes';
import http from 'hub-http/clients/apiClient';
export const useCheckEventDateLimit = (filter, tableLabel, dataSourceId) => {
  const [requestState, setRequestState] = useState({});
  useEffect(() => {
    setRequestState({
      loading: true
    });
    if (dataSourceId) {
      http.get(`/sql-reporting/v1/event-time-range/data-sources/${dataSourceId}`).then(({
        rangeInDays
      }) => {
        setRequestState({
          loading: false,
          data: rangeInDays
        });
      })
      // using any as we are not using any of properties of the error object
      .catch(e => {
        setRequestState({
          loading: false,
          error: e
        });
      });
    }
  }, [dataSourceId]);
  const {
    loading,
    error,
    data: rangeInDays
  } = requestState;
  const maxDays = rangeInDays || 31;
  const withinLimit = checkEventDateIntervalLimit(toEventDateInterval(filter), maxDays);
  const disabled = loading || !withinLimit;
  let message = undefined;
  if (withinLimit === false) {
    message = I18n.text('reporting-snowflake.filter-editor.event-date-filter.invalid.limit', {
      maxDays,
      tableLabel
    });
  }
  const {
    propertyFilterOperation
  } = toEventDateInterval(filter);
  const operator = propertyFilterOperation.get('operator');
  if (operator === IN_NEXT_TIME_UNIT) {
    message = I18n.text('reporting-snowflake.filter-editor.event-date-filter.invalid.in-next-time-unit');
  }
  if (loading) {
    message = I18n.text('reporting-snowflake.filter-editor.event-date-filter.invalid.loading');
  }
  if (error) {
    message = I18n.text('reporting-snowflake.filter-editor.event-date-filter.invalid.error');
  }
  return {
    loading,
    error,
    disabled,
    message,
    maxDays
  };
};